import styled from 'styled-components';

export const getModalStyles = ({ overrideOverlay = {}, overrideContent = {} }) => ({
  overlay: {
    zIndex: 1000000,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    ...overrideOverlay,
  },
  content: {
    position: 'absolute',
    top: 100,
    left: 0,
    right: 0,
    bottom: 'initial',
    border: 'none',
    background: '#ffffff',
    overflow: 'hidden auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: 'none',
    outline: 'none',
    padding: '10px',
    margin: '0 auto',
    width: '500px',
    height: '250px',
    ...overrideContent,
  },
});

export const modalStyles = getModalStyles({});

export const alternateFullScreenModalStyle = getModalStyles({
  overrideContent: {
    top: 0,
    padding: '0px 5px',
    width: '80%',
    height: '100%',
  },
});

//Useful containers/styled for layout out modal content
export const ModalBottomButtonContainer = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  display: flex;
  z-index: 1000000; //Resolve issue where buttons overlapping with other components (I.e. Wysiwyg) cannot be clicked.
`;

//Useful container for buttons in a fluentui/Dialog component.
export const DialogBottomButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
